import styled from 'styled-components'
import { TransitionsAnim } from 'animations/Transitions'

export interface CloseWrapperProps {
  strokeColor?: string
  backgroundColor?: string
  borderColor?: string
}
const { iconRotate } = TransitionsAnim()

export const HeaderD = styled.header<CloseWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  svg {
    width: 36px;
    height: 36px;
    padding: 7px;
    border-radius: 18px;
    border: solid 3px;
    cursor: pointer;
    border-color: ${({ borderColor }) => borderColor || '#6b66c7'};
    background-color: ${({ backgroundColor }) => backgroundColor || '#ffb000;'};

    stroke: ${({ strokeColor }) => strokeColor || '#6b66c7'};
    ${iconRotate};
  }
`
